'..'
import librariesNet from '../../assets/img/aboutus/quees_01.jpg';
import library from '../../assets/img/aboutus/quees_02.jpg';
import mind from '../../assets/img/aboutus/quees_03.png';
import howWorks1 from '../../assets/img/aboutus/comofunciona_01.jpg';
import howWorks2 from '../../assets/img/aboutus/comofunciona_02.jpg';
import howWorks3 from '../../assets/img/aboutus/comofunciona_03.jpg';
import howWorks4 from '../../assets/img/aboutus/comofunciona_04.jpg';
import ournavigate1 from '../../assets/img/aboutus/historia_01.jpg';
import ournavigate3 from '../../assets/img/aboutus/historia_03.jpg';
import ournavigate2 from '../../assets/img/aboutus/historia_02.jpg';
import ournavigate4 from '../../assets/img/aboutus/historia_04.jpg';
import team1 from '../../assets/img/aboutus/41.jpg';
import team2 from '../../assets/img/aboutus/42.jpg';
import team3 from '../../assets/img/aboutus/43.jpg';
import team4 from '../../assets/img/aboutus/44.jpg';
import team5 from '../../assets/img/aboutus/45.jpg';
import team6 from '../../assets/img/aboutus/46.jpg';

export const team = [
    {
      id:1,
      image: team1,
      name: 'Txetxu Barandiarán',
      profession: 'project_coordinator',
      alt: 'project coordinator'
    },
    {
      id:2,
      image: team2,
      name: 'Antonio de Marco',
      profession: 'project_coordinator',
      alt: 'project coordinator'
    },
    {
      id:3,
      image: team3,
      name: 'Raquel Durán',
      profession: 'communication_manager',
      alt: 'communication responsible'
    },
    {
      id:4,
      image: team4,
      name: 'Laia Benet',
      profession: 'order_manager',
      alt: 'orders responsible'
    },
    {
      id:5,
      image: team5,
      name: 'Gerard Almirall',
      profession: 'content_manager',
      alt: 'orders responsible'
    },
    {
      id:6,
      image: team6,
      name: 'Iván Elvira',
      profession: 'commercial_manager',
      alt: 'comercial responsible'
    }
  ]
  
  export const history = [
    {
      id:1,
      image: ournavigate1,
      alt: 'brain',
      year: '2012',
      title: 'little_project',
      description: 'liberdrac_appears',
    },
    {
      id:2,
      image: ournavigate2,
      alt: 'books',
      year: '2015',
      title: 'born',
      description: 'liberdrac_grows',
    },
    {
      id:3,
      image: ournavigate3,
      alt: 'worl map',
      year: '2018',
      title: 'we_are_already_100',
      description: 'libelista_expands',
    },
    {
      id:4,
      image: ournavigate4,
      alt: 'rocket',
      year: '2019',
      title: 'new_website',
      description: 'new_stage',
    }
  ]
  
  export const howWorks = [
    {
      id:1,
      image: howWorks1,
      alt: 'register pic',
      text: 'register'
    },
    {
      id:2,
      image: howWorks2,
      alt: 'loupe pic',
      text: 'browse'
    },
    {
      id:3,
      image: howWorks3,
      alt: 'library net',
      text: 'choose_delivery'
    },
    {
      id:4,
      image: howWorks4,
      alt: 'bag',
      text: 'support_store'
    }
  ]
  
  export  const aboutus = [
    {
      id:1,
      image: librariesNet,
      alt: 'libraries net',
      text: 'what_is_text_1'
    },
    {
      id:2,
      image: library,
      alt: 'library',
      text: 'what_is_text_2'
    },
    {
      id:3,
      image: mind,
      alt: 'mind',
      text: 'what_is_text_3'
    }
  ]